<template>
  <div class="container" @keydown="cancelTabPropgation">
    <PersonalAreaNavBar
      backurl="personal-area-privateinfo"
      :title="$t('personalArea.infoTitle')"
    />
    <div style="padding: 15px; overflow-x: hidden">
      <PersonalAreaFormInput :title="$t('login.name')">
        <input tabindex="0" class="p-edit" v-model="firstName" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('login.lastName')">
        <input tabindex="1" class="p-edit" v-model="lastName" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.mosad')">
        <input tabindex="2" class="p-edit" v-model="institution" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.mail')">
        <div class="miss-mail lang-dir" v-if="email == ''">
          <input type="email" class="p-edit m-center" />
          <Icons icon="pa-warning" height="16px" width="16px" />
        </div>
        <input v-else class="p-edit" v-model="email" />
        <template v-slot:footer v-if="email == ''">
          <div class="miss-mail-msg">
            <p>
              <b>{{ $t("personalArea.yourMailMissToUs") }}</b>
            </p>
            <p>{{ $t("personalArea.wePromiseNotPublish") }}</p>
          </div>
        </template>
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.country')">
        <input tabindex="4" class="p-edit" v-model="land" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.landForUs')">
        <input tabindex="5" class="p-edit" v-model="us_country" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.city')">
        <input tabindex="6" class="p-edit" v-model="city" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.address')">
        <input tabindex="7" class="p-edit" v-model="address" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.houseNumber')">
        <input tabindex="8" class="p-edit" v-model="house_number" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.tel')">
        <input tabindex="9" class="p-edit" v-model="phone" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.cell')">
        <input tabindex="10" class="p-edit" v-model="cellPhone" />
      </PersonalAreaFormInput>
      <PersonalAreaFormInput :title="$t('personalArea.addInfo')">
        <textarea tabindex="11" class="p-edit" v-model="user_notes" />
      </PersonalAreaFormInput>
    </div>
    <div class="save-info">
      <div class="btn btn-larg" @click="sendUserData">
        {{ $t("personalArea.sendChanges") }}
      </div>
    </div>
  </div>
</template>

<script>
import Icons from "../Icons/Icons.vue";
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
import PersonalAreaFormInput from "./PersonalAreaFormInput.vue";
import mixPersonalArea from "@/mixing/mixPersonalArea";
import { Axios } from "@/services/_axios";
export default {
  mixins: [mixPersonalArea],
  components: { PersonalAreaNavBar, PersonalAreaFormInput, Icons },
  methods: {
    cancelTabPropgation(e) {
      if (e.code == "Tab") {
        e.stopPropagation();
      }
    },
    async sendUserData() {
      let message;
      let messtype;
      try {
        const data = { ...this.$data };
        const ret = await Axios.post("/api/personalarea", data);
        if (ret.data) {
          message = this.$t("general.sendSuccess");
          messtype = "success";
        } else {
          message = this.$t("general.failed");
          messtype = "error";
        }
      } catch {
        message = this.$t("general.failed");
        messtype = "error";
      }

      const notification = {
        type: messtype,
        message,
        timeout: 2000,
      };
      this.$notify(notification);
    },
  },
};
</script>

<style lang="scss" scoped>
input {
}
.miss-mail {
  color: rgb(167, 97, 15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
}
.p-edit {
  min-height: 23px;
  width: 100%;
  border-width: 0px;
  background: transparent;
}
.miss-mail-msg {
  color: #a7610f;
  padding-top: 6px;
  font-size: 11px;
  line-height: 120%;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.save-info {
  background: #dedede;
  display: flex;
  height: 56px;
  padding: 15px;
  justify-content: center;
  align-items: center;
  position: sticky;
  bottom: 0px;
}
.m-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
